import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { postResetPassword } from '../../api/Api';
import RequestResultOverlay from '../../components/overlays/RequestResultOverlay';
import { useLoadingContext } from '../../contexts/LoadingContext';
import { validateEmail } from '../../utilities/validators';

const ResetPasswordPage = () => {
  const params = useParams();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('algo salio mal');
  const [expired, setExpired] = useState(false);
  const [displayOverlay, setDisplayOverlay] = useState(false);

  const { setLoading } = useLoadingContext();

  useEffect(() => {
    const paramsList = params.data.split(',');
    const token = paramsList.length > 0 && paramsList[0];
    const email = paramsList.length > 1 && paramsList[1];
    if ((!token && !email) || !validateEmail(email)) {
      history.push('/');
    }
    setToken(paramsList[0]);
    setEmail(paramsList[1]);
  }, []);

  const sendRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    let response;
    try {
      response = await postResetPassword({
        email,
        token,
        password,
      });
      if (response.ok) {
        setDisplayOverlay(true);
      } else {
        setErrorMsg(
          'Algo salio mal, quizas este pedido esta expirado. Por favor intente nuevamente'
        );
        setExpired(true);
      }
    } catch (error) {
      console.log('error', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (password.length > 3 && repeatPassword.length > 3 && password !== repeatPassword) {
      setErrorMsg("Los campos 'Contraseña' y 'Repetir Contraseña' no coinciden");
    } else {
      setErrorMsg('');
    }
  }, [password, repeatPassword]);

  const disabled = password !== repeatPassword || password.length < 3;

  return (
    <section className="hero is-fullheight">
      <div className="columns is-centered">
        <div className="hero-body">
          <div className="container">
            <h1 className="title">Reestablecer su contraseña</h1>
            <h2 className="subtitle">Ingrese su nueva contraseña</h2>
            <div className="column">
              <section>
                <form action="">
                  <div className="field">
                    <label htmlFor="">Contraseña</label>
                    <div className="control">
                      <input
                        className={`input is-large ${errorMsg && 'is-danger'}`}
                        type="password"
                        placeholder=""
                        autoFocus=""
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="">Retetir contraseña</label>
                    <div className="control">
                      <input
                        className={`input is-large ${errorMsg && 'is-danger'}`}
                        type="password"
                        placeholder=""
                        autoFocus=""
                        onChange={(e) => setRepeatPassword(e.target.value)}
                      />
                    </div>
                    {errorMsg && <h2 className="help is-danger is-size-3">{errorMsg}</h2>}
                    {expired && (
                      <Link to="/fp" replace className="is-link is-size-4">
                        Solicitar nuevamente...
                      </Link>
                    )}
                  </div>
                  <button
                    className="button is-block is-primary is-large is-fullwidth"
                    onClick={sendRequest}
                    disabled={disabled}
                  >
                    Enviar
                  </button>
                </form>
              </section>
            </div>
            <div className="section">
              <Link to="/" replace className="button is-danger is-size-4">
                Cancelar
              </Link>
            </div>
          </div>
        </div>
      </div>
      <RequestResultOverlay
        title={''}
        isActive={displayOverlay}
        description={'Su contraseña fue cambiada con exito!'}
        onPressConfirm={() => history.push('/')}
        buttonTitle={'OK'}
      />
    </section>
  );
};

export default ResetPasswordPage;
